import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import CompanySitesAdd from "../../../components/CompanySitesAdd";
import {
  delete_icon,
  edit_icon,
  green_icon,
  red_icon,
  user,
  user_icon,
  user_img,
} from "../../../assets/imgs";
import { cameraData, group1, group2, group3 } from "../../redux/api/dummyJson";
import CompanyGroupView from "../../../components/CompanyGroupView";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";
import CompanyUserReport from "../Report/CompanyUserReport";
import CompanyIndNotifications from "../Notifications/CompanyIndNotifications";
import CompanySlotMain from "../CompanySlot/CompanySlotMain";
import CompanyAdminAlertTypes from "../AlertTypes/CompanyAdminAlertTypes";
import AlertMainCompany from "../AlertTypes/AlertMainCompany";
import CameraCompanySite from "./CameraCompanySite";
import CancelIcon from "@mui/icons-material/Cancel";
import CompanyAllReports from "./CompanyAllReports";
import AlreadyComPopup from "../../../components/Popup/AlreadyComPopup";
import CommonImagePopup from "../../../components/CommonImagePopup";

const CompanySitesView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [btnTab, setBtnTab] = useState(1);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteSiteAdmin, setDeleteSiteAdmin] = useState(false);
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [siteList, setSiteList] = useState([]);
  const [show, setShow] = useState(false);
  const [siteID, setSiteID] = useState(
    location?.state?.data?.id ? location?.state?.data?.id : "",
  );

  const [confirm, setConfirm] = useState(false);
  const groupNameRef = useRef(null);
  const [groupList, setGroupList] = useState([]);
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckDataGroup, setEmailCheckDataGroup] = useState({});
  const [fullData, setFullDate] = useState({});
  const [fullData2, setFullDate2] = useState({});
  const [flagEmail2, setFlagEmail2] = useState(0);

  const formDataObj = {
    name: "",
    address: "",
    location: "",
    code: "",
    adminName: "",
    adminEmail: "",
    adminMobile: "",
    adminImage: "",
    adminName2: "",
    adminEmail2: "",
    adminMobile2: "",
    adminImage2: "",
  };
  const [formData, setFormData] = useState(formDataObj);

  // console.log("formData", formData);

  const fileInputRef = useRef(null);

  const groupFormObj = {
    groupName: "",
    groupEmail: "",
    groupMobile: "",
    groupCategory: "",
    groupImage: "",
    alert: 0,
    beep: 1,
  };

  const [groupUsers, setGroupUsers] = useState([]);
  const [groupForm, setGroupForm] = useState(groupFormObj);
  console.log("groupForm", groupForm);

  const [groupErrors, setGroupErrors] = useState({});

  const [errors, setErrors] = useState({});
  const [siteErrors, setSiteErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [popup2, setPopup2] = useState(false);
  const [admindetails, setAdminDetails] = useState({});
  const [groupPopup, setGroupPopup] = useState(false);
  const [flagEmail, setFlagEmail] = useState(0);

  const [selectedCamera, setSelectedCamera] = useState(null);

  const type = location?.state?.type;
  const data = location?.state?.data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (formData?.adminEmail?.length < 2) {
    //   setEmailCheckData({});
    // }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setSiteErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const [createdAt, setCreatedAt] = useState("");
  const [locList, setLoclist] = useState([]);

  const getLocationList = () => {
    get(URL.COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    get(URL.SITE_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.data?.[0];
        setFullDate(data);
        let ob = {
          name: "",
          address: "",
          location: "",
          code: "",
          adminName: "",
          adminEmail: "",
          adminMobile: "",
          adminImage: "",
          is_email_verified: data?.is_email_verified,
        };

        if (data?.site_name) {
          ob.name = data?.site_name;
        }

        if (data?.site_code) {
          ob.code = data?.site_code;
        }

        if (data?.site_location) {
          ob.location = data?.site_location;
        }

        if (data?.site_address) {
          ob.address = data?.site_address;
        }

        if (data?.user_name) {
          ob.adminName = data?.user_name;
        }

        if (data?.user_phone) {
          ob.adminMobile = data?.user_phone;
        }

        if (data?.user_email) {
          ob.adminEmail = data?.user_email;
        }

        if (data?.profile_image) {
          ob.adminImage = data?.profile_image;
        }

        if (data?.created_at) {
          setCreatedAt(moment(data?.created_at).format("DD-MM-YYYY"));
        }

        setFormData(ob);
        setEmailCheckFlag(1);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getGropRole = () => {
    get(URL.GROUP_ROLE_LIST)
      .then((res) => {
        setGroupList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getGroupList = () => {
    let payload = new FormData();
    payload.append("knf_type", 1);
    payload.append("site_id", location?.state?.data?.id);
    post(URL.GROUP_USER_LIST, payload)
      .then((res) => {
        let temp = [];
        res?.lists?.map((item, ind) => {
          let obj = {
            ...item,
          };
          if (item?.group_category == 3) {
            obj.group_category = 1;
          }
          if (item?.group_category == 4) {
            obj.group_category = 2;
          }
          if (item?.group_category == 5) {
            obj.group_category = 3;
          }
          temp.push(obj);
        });
        if (res?.lists?.length > 0) {
          setGroupUsers(res?.lists);
        } else {
          setGroupUsers([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getLocationList();
    if (location?.state?.data?.id) {
      getView();
    }

    if (type !== "add") {
      getGropRole();
      getGroupList();
    }
  }, []);

  const groupUserStatus = (id) => {
    get(URL.GROUP_USER_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getGroupList();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (formData?.name?.length == 0) newErrors.name = "Site Name is required";
    if (formData?.code?.length == 0) newErrors.code = "Site Code is required";
    if (formData?.location?.length == 0)
      newErrors.location = "Site location is required";
    if (formData?.address?.length == 0)
      newErrors.address = "Site address is required";

    if (formData?.adminName?.length == 0)
      newErrors.adminName = "Site Admm Name is required";
    if (
      formData?.adminEmail?.length == 0 ||
      !emailRegex.test(formData?.adminEmail)
    )
      newErrors.adminEmail = "Valid Email is required";

    if (!singaporeMobileRegex.test(formData?.adminMobile)) {
      newErrors.adminMobile = "Enter valid 8-digit mobile number";
    }

    // if (!siteID && formData?.adminImage?.length == 0)
    //   newErrors.adminImage = "site admin image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("Submit successful", formData);
      let payload = new FormData();
      payload.append("name", formData.adminName);
      payload.append("email", formData.adminEmail);
      payload.append("phone", formData.adminMobile);
      payload.append("site_name", formData.name);
      payload.append("site_code", formData.code);
      payload.append("site_location", formData.location);
      payload.append("site_address", formData.address);
      payload.append("profile_image", formData.adminImage);
      payload.append("site_status", 1);
      payload.append("knf_type", 2);

      if (formData?.email_verified) {
        payload.append("email_verified", formData?.email_verified);
      }

      if (siteID) {
        payload.append("site_id", siteID);
        if (emailCheckData?.company?.id) {
          payload.append("company_id", emailCheckData?.company?.id);
        }
        editApi(payload);
      } else if (formData?.email_verified) {
        payload.append("site_id", "");
        editApi(payload);
      } else {
        addApi(payload);
      }
    }
  };
  const handleDeleteSiteAdmin = () => {
    // if (validate()) {
    // console.log("Submit successful", formData);
    let payload = new FormData();
    payload.append("site_email_verified", 0);
    payload.append("name", formData.adminName2);
    payload.append("email", formData.adminEmail2);
    payload.append("phone", formData.adminMobile2);
    payload.append("site_name", formData.name);
    payload.append("site_code", formData.code);
    payload.append("site_location", formData.location);
    payload.append("site_address", formData.address);
    payload.append("profile_image", formData.adminImage);
    payload.append("site_status", 1);
    payload.append("knf_type", 2);

    if (formData?.email_verified) {
      payload.append("email_verified", formData?.email_verified);
    }

    if (siteID) {
      if (siteID) {
        payload.append("site_id", siteID);
      }
      if (emailCheckData?.company?.id) {
        payload.append("company_id", emailCheckData?.company?.id);
      }
      editApi(payload);
      setDeleteSiteAdmin(false);
    } else {
      editApi(payload);
      setDeleteSiteAdmin(false);
    }
    // }
  };

  const addApi = (payload) => {
    post(URL.SITE_ADD, payload)
      .then((res) => {
        if (res?.status == "success") {
          setEmailCheckFlag(0);
          toast.success(res?.message);
          navigate("/company-sites");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const editApi = (payload) => {
    post(URL.SITE_UPDATE, payload)
      .then((res) => {
        if (res?.status == "success") {
          setEmailCheckFlag(0);
          toast.success(res?.message);
          // navigate("/company-sites");
          getView();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  //site admin

  const siteValidate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (formData?.adminName?.length == 0)
      newErrors.adminName = "Site Admm Name is required";
    if (
      formData?.adminEmail?.length == 0 ||
      !emailRegex.test(formData?.adminEmail)
    )
      newErrors.adminEmail = "Valid Email is required";

    if (
      formData?.adminMobile?.length == 0 ||
      !singaporeMobileRegex.test(formData?.adminMobile)
    ) {
      newErrors.adminMobile = "Enter valid 8-digit Singapore number";
    }

    if (formData?.adminImage?.length == 0)
      newErrors.adminImage = "site admin image is required";
    setSiteErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSiteAdd = () => {
    if (
      siteValidate(
        formData.adminName,
        formData.adminEmail,
        formData.adminMobile,
        formData.adminImage,
      )
    ) {
      const newSite = {
        id: Date.now(),
        adminName: formData.adminName,
        adminEmail: formData.adminEmail,
        adminMobile: formData.adminMobile,
        adminImage: formData.adminImage,
        active: true,
        editing: false,
      };
      setSiteList((prev) => [...prev, newSite]);
      setFormData((prev) => ({
        ...prev,
        adminName: "",
        adminEmail: "",
        adminMobile: "",
      }));
      setShow(true);
    }
  };

  const handleSiteChange = (field, value) => {
    if (field == "adminImage") {
      let image = value.target.files[0];
      if (image) {
        setSiteList((prev) =>
          prev.map((site) => ({
            ...site,
            [field]: image,
          })),
        );
      }
    } else {
      setSiteList((prev) => prev.map((site) => ({ ...site, [field]: value })));
    }

    setSiteErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleGroupChange = (e) => {
    const { name, value } = e.target;
    if (name == "groupCategory" && value == 3) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 1, beep: 1 }));
    } else if (name == "groupCategory" && value == 4) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else if (name == "groupCategory" && value == 5) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else {
      setGroupForm((prev) => ({ ...prev, [name]: value }));
    }
    setGroupErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEdit = (id) => {
    setSiteList((prev) =>
      prev.map((site) =>
        site.id === id ? { ...site, editing: !site.editing } : site,
      ),
    );
  };

  // console.log('siteList', siteList);

  const handleDelete = () => {
    const newSite = {
      id: Date.now(),
      adminName: formData.adminName,
      adminEmail: formData.adminEmail,
      adminMobile: formData.adminMobile,
      adminImage: formData.adminImage,
      active: true,
      editing: false,
    };
    setSiteList([newSite]);
    setFormData({
      adminName: "",
      adminEmail: "",
      adminMobile: "",
      adminImage: "",
    });
    setShow(true);
    setConfirm(false);
    setPopup(false);
  };

  //group users

  const validateGroup = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (groupForm?.groupName?.length == 0)
      newErrors.groupName = "Group user name is required";
    if (
      groupForm.groupEmail?.length == 0 ||
      !emailRegex.test(groupForm.groupEmail)
    )
      newErrors.groupEmail = "Valid email is required";

    if (
      groupForm.groupMobile?.length == 0 ||
      !singaporeMobileRegex.test(groupForm.groupMobile)
    ) {
      newErrors.groupMobile = "Enter valid 8-digit Singapore number";
    }

    if (groupForm.groupCategory?.length == 0)
      newErrors.groupCategory = "Category is required";
    // if (!groupForm.groupImage) newErrors.groupImage = "user image is required";

    if (groupForm.groupCategory == 3) {
      if (!groupForm.alert) {
        newErrors.alert = "Alert Notifications should be enabled";
      }

      if (groupForm.beep && !groupForm.alert) {
        newErrors.beep =
          "Beep Sound cannot be enabled without enabling Alert Notifications";
      }
    }
    setGroupErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetGroup = () => {
    setGroupForm({
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 0,
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    getGroupList();
  };

  const handleGroupAdd = () => {
    if (validateGroup()) {
      let formdata = new FormData();
      formdata.append("name", groupForm.groupName);
      formdata.append("phone", groupForm.groupMobile);
      formdata.append("email", groupForm.groupEmail);
      formdata.append("knf_type", 1);
      formdata.append("notification_alert", groupForm.alert);
      formdata.append("beep_sound", groupForm.beep);
      formdata.append("group_category", groupForm.groupCategory);
      formdata.append("site_id", location?.state?.data?.id);

      if (groupForm.groupImage?.name) {
        formdata.append("profile_image", groupForm.groupImage);
      }

      if (groupForm?.id) {
        post(URL.GROUP_USER_UPDATE + groupForm?.id, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(URL.GROUP_USER_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      // setGroupUsers((prev) => [...prev, newUser]);
    }
  };

  const deleteGroupUser = (id) => {
    post(URL.GROUP_USER_DELETE + id, {})
      .then((res) => {
        if (res?.status == "success") {
          handleResetGroup();
          toast.success(res?.message);
          setGroupPopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleSiteImage = (event, name) => {
    let image = event.target.files[0];
    if (image) {
      setFormData((prev) => ({
        ...prev,
        [name]: image,
      }));

      setSiteErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleGroupImage = (event, name) => {
    let image = event.target.files[0];
    if (image) {
      setGroupForm((prev) => ({
        ...prev,
        [name]: image,
      }));

      setGroupErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleGroupEdit = (item) => {
    if (item) {
      setFullDate2(item);
      setGroupForm({
        id: item?.id,
        groupName: item?.name,
        groupEmail: item?.email,
        groupMobile: item?.phone,
        groupCategory: item?.group_category,
        alert: item?.notification_alert,
        beep: item?.beep_sound,
        groupImage: item?.profile_image,
        groupEmail_verify: true,
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      setTimeout(() => {
        if (groupNameRef.current) {
          groupNameRef.current.focus();
        }
      }, 0);
    }
  };

  const autoFetchData = (data_new, email_type) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };

    let emailCheck_ = {
      ...data,
    };
    let ob = {
      name: "",
      address: "",
      location: "",
      code: "",
      adminName: "",
      adminEmail: "",
      adminMobile: "",
      adminImage: "",
      adminName2: "",
      adminEmail2: "",
      adminMobile2: "",
      email_verified: data?.id ? 1 : 0,
    };
    if (data?.knf_company_site_id) {
      setSiteID(data?.knf_company_site_id);
    }

    if (data?.knf_company_site_id == data?.company?.site?.id) {
      if (data?.company?.site?.name) {
        ob.name = data?.company?.site?.name;
      }
      if (data?.company?.site?.address) {
        ob.address = data?.company?.site?.address;
      }
      if (data?.company?.site?.code) {
        ob.code = data?.company?.site?.code;
      }
      if (data?.company?.site?.location) {
        ob.location = data?.company?.site?.location;
      }
    } else {
      emailCheck_ = {
        ...emailCheck_,
        company: {
          ...emailCheck_?.company,
          site: null,
        },
      };
    }

    if (email_type == "email2") {
      if (data?.phone) {
        ob.adminMobile2 = data?.phone;
      }

      if (data?.email) {
        ob.adminEmail2 = data?.email;
      }
      if (data?.name) {
        ob.adminName2 = data?.name;
      }
      ob.adminEmail = formData?.adminEmail ? formData?.adminEmail : "";
      ob.adminMobile = formData?.adminMobile ? formData?.adminMobile : "";
      ob.adminName = formData?.adminName ? formData?.adminName : "";
      ob.name = formData?.name;
      ob.address = formData?.address;
      ob.code = formData?.code;
      ob.location = formData?.location;
      console.log("ob", ob);
    } else {
      if (data?.email) {
        ob.adminEmail = data?.email;
      }

      if (data?.phone) {
        ob.adminMobile = data?.phone;
      }

      if (data?.name) {
        ob.adminName = data?.name;
      }
    }

    if (data?.adminImage) {
      ob.adminImage = data?.adminImage;
    }

    setFormData(ob);
    setEmailCheckData(emailCheck_);
  };

  const autoFetchDataGroup = (data_new) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };
    setEmailCheckDataGroup(data);
    let ob = {
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 1,
      email_verified: data?.id ? 1 : 0,
    };
    if (data?.knf_company_site_id) {
      setSiteID(data?.knf_company_site_id);
    }

    if (data?.id) {
      ob.id = data?.id;
    }

    if (data?.email) {
      ob.groupEmail = data?.email;
      ob.groupEmail_verify = true;
    }

    if (data?.name) {
      ob.groupName = data?.name;
    }
    if (data?.phone) {
      ob.groupMobile = data?.phone;
    }
    if (data?.profile_url) {
      ob.groupImage = data?.profile_url;
    }
    if (data?.knf_type) {
      ob.groupCategory = data?.knf_type;
    }

    if (data?.beep_sound) {
      ob.beep = data?.beep_sound;
    }

    if (data?.notification_alert) {
      ob.alert = data?.notification_alert;
    }

    setGroupForm(ob);
  };

  const emailCheck = (event, email_type) => {
    let formdata = new FormData();
    let count = 1;
    if (email_type) {
      if (formData.adminEmail2?.length > 0) {
        count = count;
      } else {
        count = count + 1;
      }
    } else {
      if (formData.adminEmail?.length > 0) {
        count = count;
      } else {
        count = count + 1;
      }
    }
    if (count == 1) {
      if (event == 2) {
        formdata.append("email", groupForm.groupEmail);
      } else {
        if (email_type) {
          formdata.append("email", formData.adminEmail2);
        } else {
          formdata.append("email", formData.adminEmail);
        }
      }
      post("user/" + URL.EMAIL_CHECK, formdata)
        .then((res) => {
          if (event == 2) {
            setFlagEmail2(0);
          } else {
            setFlagEmail(0);
          }

          let data = res?.userData?.[0];
          //   if (res?.exists && res?.message?.includes("admin")) {
          // }
          if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else if (res?.exists && location?.state?.type == "edit") {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup2(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } else {
            if (res?.userData?.length > 0) {
              setEmailCheckFlag(1);
              if (data?.user?.knf_type == 2) {
                autoFetchData(data, email_type);
              } else if (
                data?.user?.knf_type >= 3 &&
                data?.user?.knf_type <= 5
              ) {
                autoFetchDataGroup(data);
              } else if (data?.user?.knf_type == null) {
                if (event == 2) {
                  autoFetchDataGroup(data);
                } else {
                  autoFetchData(data, email_type);
                }
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              if (event == 2) {
                let ob = {
                  ...(groupForm.id ? groupForm : groupFormObj),
                  groupEmail: groupForm.groupEmail,
                };
                if (groupForm.id) {
                  ob.id = groupForm.id;
                }
                setGroupForm(ob);
              } else {
                if (email_type == "email2") {
                  let ob = {
                    ...formData,
                    adminEmail: formData.adminEmail,
                    adminEmail2: formData.adminEmail2,
                  };
                  setFormData(ob);
                } else {
                  let ob = {
                    ...(location?.state?.type == "edit"
                      ? formData
                      : formDataObj),
                    adminEmail: formData.adminEmail,
                  };
                  setFormData(ob);
                  setEmailCheckFlag(1);
                }
              }
              setEmailCheckData({});
              if (location?.state?.type !== "edit") {
                toast("please enter all required fields");
              }
              if (event == 2) {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  const emailCheckGroup = (event) => {
    let formdata = new FormData();
    let count = 1;
    if (groupForm.groupEmail?.length > 0) {
      count = count;
    } else {
      count = count + 1;
    }
    if (count == 1) {
      formdata.append("email", groupForm.groupEmail);
      post("user/" + URL.EMAIL_CHECK, formdata)
        .then((res) => {
          setFlagEmail2(0);

          let data = res?.userData?.[0];
          //   if (res?.exists && res?.message?.includes("admin")) {
          // }
          if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else if (res?.exists && groupForm?.id) {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup2(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } else {
            if (res?.userData?.length > 0) {
              setEmailCheckFlag(1);
              if (data?.user?.knf_type >= 3 && data?.user?.knf_type <= 5) {
                autoFetchDataGroup(data);
              } else if (data?.user?.knf_type == null) {
                autoFetchDataGroup(data);
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              let ob = {
                ...(groupForm.id ? groupForm : groupFormObj),
                groupEmail: groupForm.groupEmail,
                groupEmail_verify: true,
              };
              if (groupForm.id) {
                ob.id = groupForm.id;
              }
              setGroupForm(ob);
              setEmailCheckData({});
              if (!groupForm.id) {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  const siteAdminImgRef = useRef(null);
  const [open, setOpen] = useState();

  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={type} />
      {popup2 && (
        <AlreadyComPopup
          setPopup={setPopup2}
          admindetails={admindetails}
          locList={locList}
        />
      )}

      <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 black">
        Site Admin Section{" "}
      </p>

      {type !== "view" && (
        <>
          {!show && (
            <div className="d-flex flex-row ac-js gap-4">
              <div className="col-md-2 position-relative mb-5">
                <p
                  className="f3 mb-1 primary d-flex"
                  style={{
                    marginTop: "37px",
                  }}
                >
                  Admin Email<span className="text-danger">*</span>
                </p>
                <input
                  name="adminEmail"
                  value={formData.adminEmail}
                  onChange={(val) => {
                    setFlagEmail(1);
                    handleChange(val);
                    setEmailCheckFlag(0);
                  }}
                  className="input-box w-100 "
                  type="email"
                  placeholder="Admin Email"
                  // disabled={type == "edit" ? true : false}
                />
                {errors.adminEmail && (
                  <p className="err">{errors.adminEmail}</p>
                )}
                {formData.adminEmail?.length > 2 && (
                  <p
                    className="position-absolute text-primary pointer end-0 fw-bold"
                    onClick={() => {
                      if (location?.state?.type == "edit") {
                        if (fullData?.user_email == formData.adminEmail) {
                          toast.error("Same Email Entered");
                        } else {
                          emailCheck(1);
                        }
                      } else {
                        emailCheck(1);
                      }
                    }}
                  >
                    Check
                  </p>
                )}
                {type != "add" && (
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={formData?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {formData?.is_email_verified
                        ? "Verified"
                        : "Not Verified"}
                    </p>
                  </div>
                )}
              </div>
              <div className="col-md-2 mb-2">
                <p className="f3 mb-1 primary d-flex">
                  Site admin name<span className="text-danger">*</span>
                </p>
                <input
                  className={`input-box w-100 ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
                  name="adminName"
                  value={formData.adminName}
                  onChange={handleChange}
                  type="text"
                  placeholder="Site admin name"
                  disabled={
                    emailCheckFlag == 0
                      ? true
                      : emailCheckData?.name
                        ? true
                        : false
                  }
                />
                {errors.adminName && <p className="err">{errors.adminName}</p>}
              </div>

              <div className="col-md-2 mb-2">
                <p className="f3 mb-1 primary d-flex">
                  Singapore Mobile<span className="text-danger">*</span>
                </p>
                <input
                  name="adminMobile"
                  value={formData.adminMobile}
                  onChange={handleChange}
                  maxLength={8}
                  className={`input-box w-100 ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 8))}
                  type="number"
                  placeholder="+65 Mobile"
                  disabled={
                    emailCheckFlag == 0
                      ? true
                      : emailCheckData?.phone
                        ? true
                        : false
                  }
                />
                {errors.adminMobile && (
                  <p className="err">{errors.adminMobile}</p>
                )}
              </div>

              {type !== "add" && formData.adminImage && (
                <div className="col-md-1 ">
                  <p className="f3 primary d-flex">Site Admin Image</p>
                  <img
                    src={
                      typeof formData.adminImage === "string"
                        ? formData.adminImage
                        : window.URL.createObjectURL(formData.adminImage)
                    }
                    style={{
                      height: "100px",
                      width: "100px",
                      objectFit: "cover",
                      borderRadius: "50px",
                    }}
                    onClick={() => fileInputRef.current?.click()}
                    className="pointer"
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => handleSiteImage(e, "adminImage")}
                  />
                </div>
              )}

              {(type !== "edit" || !formData.adminImage) && (
                <div className="col-md-2 ">
                  <p
                    className="f3 primary d-flex"
                    style={{ marginBottom: "-4%" }}
                  >
                    Site Admin Image
                  </p>
                  <span className="text-danger fs-12">
                    JPG, JPEG, PNG only | Max size: 5MB
                  </span>
                  <input
                    ref={siteAdminImgRef}
                    name="adminImage"
                    onChange={(e) => handleSiteImage(e, "adminImage")}
                    className={`input-box w-100 ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
                    type="file"
                    placeholder="Site Admin Image"
                    accept="image/*"
                    style={{ display: "none" }}
                    disabled={emailCheckFlag == 0 ? true : false}
                  />

                  <div className="col-md-3 d-flex ac-jb gap-3">
                    <img
                      src={
                        formData.adminImage
                          ? typeof formData.adminImage === "string"
                            ? formData.adminImage
                            : window.URL.createObjectURL(formData.adminImage)
                          : user_img
                      }
                      alt="Site Logo"
                      className={`user pointer ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
                      style={{
                        borderRadius: "50px",
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                      onClick={() => siteAdminImgRef.current?.click()}
                    />

                    <img
                      src={edit_icon}
                      alt="Edit"
                      className={`edit-btn pointer ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => siteAdminImgRef.current?.click()}
                      disabled={emailCheckFlag == 0 ? true : false}
                    />
                  </div>
                </div>
              )}
              {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") ||
              givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE") ? (
                <div className="col-md-1 mt-4 ">
                  {flagEmail == 0 && type == "edit" && (
                    <button
                      // onClick={handleSiteAdd}
                      onClick={() => handleSubmit()}
                      className="medium-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                    >
                      {/* <CheckCircleIcon fontSize="small" /> */}
                      Save
                    </button>
                  )}
                </div>
              ) : null}
              {type == "edit" && (
                <div className="col-md-1 mt-4 ">
                  <button
                    onClick={() => setDeletePopup(true)}
                    // disabled
                    className="medium-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                  >
                    {/* <DeleteIcon fontSize="small" /> */}
                    Delete
                  </button>
                </div>
              )}
            </div>
          )}
          <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-1 text-danger my-3">
            *Minimum one site admin is required
          </p>
        </>
      )}

      {type == "view" && (
        <div className="d-flex p-1">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={formData?.adminName}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Admin Email
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={formData?.adminEmail}
              />
              <div className="d-flex ac-js mt-2 gap-2">
                <img
                  src={formData?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {formData?.is_email_verified ? "Verified" : "Not Verified"}
                </p>
              </div>
            </div>

            <div className="p-2 mb-2">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Address
              </p>
              <input
                className="input-box"
                name="address"
                value={formData?.address}
                readOnly
                type="text"
                placeholder="Site Address"
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Admin Primary Mobile
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={formData?.adminMobile}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box"
                name="name"
                value={`${formData?.name} - ${formData?.code}`}
                readOnly
                type="text"
                placeholder="Site Name"
              />
            </div>

            <div className="p-2 mb-2 mt-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                Site Location
              </p>
              <select
                name="location"
                value={formData?.location}
                className="input-box"
                type="text"
                disabled
              >
                {" "}
                <option>Select Location</option>
                {locList?.map((item) => {
                  return (
                    <option value={item?.id} key={item?.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {/* {formData?.adminImage && ( */}
          <div className="col-md-4 p-3 d-flex ac-jc">
            <img
              src={formData?.adminImage ? formData?.adminImage : user_img}
              className="user pointer"
              style={{
                height: "100px",
                width: "100px",
                borderRadius: "50px",
              }}
              onClick={() =>
                setOpen(formData?.adminImage ? formData?.adminImage : user_img)
              }
            />
          </div>
          {/* )} */}
        </div>
      )}

      {type == "view" && (
        <div className="col-md-10 p-3 d-flex ac-jb mt-3">
          <div className="p-2 mb-2">
            <button
              className={`${btnTab == 1 ? "submit-btn" : "back-btn"} px-4`}
              onClick={() =>
                // navigate("/company-user-report", { state: { type: "company" } })
                setBtnTab(1)
              }
            >
              Group Users
            </button>
          </div>
          <div className="p-2 mb-2">
            <button
              className={`${btnTab == 2 ? "submit-btn" : "back-btn"}`}
              onClick={() => {
                // navigate("/company-user-report", {
                //   state: { type: "company" },
                // });
                setBtnTab(2);
              }}
            >
              View Report
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className={`${btnTab == 3 ? "submit-btn" : "back-btn"}`}
              onClick={() => {
                // navigate("/company-ind");
                setBtnTab(3);
              }}
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className={`${btnTab == 4 ? "submit-btn" : "back-btn"}`}
              onClick={() => {
                // navigate("/company-slot", { state: { type: "slot" } });
                setBtnTab(4);
              }}
            >
              Slot Days
            </button>
          </div>
          <div className="p-2 mb-2">
            <button
              className={`${btnTab == 5 ? "submit-btn" : "back-btn"}`}
              onClick={() => {
                // navigate("/company-admin-alert-types", {
                //   state: { type: "slot", editable: true },
                // });
                setBtnTab(5);
              }}
            >
              Camera
            </button>
          </div>
          {/* <div className="p-2 mb-2">
            <button
              className={`${btnTab == 6 ? "submit-btn" : "back-btn"}`}
              onClick={() => {
                // navigate("/company-admin-camera", { state: { type: "slot" } });
                setBtnTab(6);
              }}
            >
              Cameras
            </button>
          </div> */}
        </div>
      )}

      {siteList.map((site) => (
        <div
          key={site.id}
          className="row align-items-center "
          style={{ fontSize: "14px" }}
        >
          {/* Admin Name */}
          <div className="col-md-2 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminName}
                onChange={(e) => handleSiteChange("adminName", e.target.value)}
              />
            ) : (
              <p className="mb-0">{site.adminName}</p>
            )}
          </div>

          {/* Admin Email */}
          <div className="col-md-3 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminEmail}
                disabled
              />
            ) : (
              <p className="mb-0">{site.adminEmail}</p>
            )}
          </div>

          {/* Admin Mobile */}
          <div className="col-md-2 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminMobile}
                onChange={(e) =>
                  handleSiteChange("adminMobile", e.target.value)
                }
              />
            ) : (
              <p className="mb-0">{site.adminMobile}</p>
            )}
          </div>

          {/* this design is from chat gpt so careful */}
          {/* Admin Image */}
          <div className="col-md-1 d-flex justify-content-center">
            {site.editing ? (
              <div className="position-relative">
                <input
                  type="file"
                  accept="image/*"
                  id={`file-upload-${site.id}`}
                  style={{ display: "none" }}
                  onChange={(e) => handleSiteChange("adminImage", e)}
                />
                <label
                  htmlFor={`file-upload-${site.id}`}
                  className="d-flex align-items-center justify-content-center rounded-circle border"
                  style={{
                    width: "50px",
                    height: "50px",
                    cursor: "pointer",
                    background: "#f8f9fa",
                  }}
                >
                  <img
                    src={
                      site.adminImage
                        ? URL.createObjectURL(site.adminImage)
                        : user
                    }
                    alt="preview"
                    className="rounded-circle"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <span
                    className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle"
                    style={{
                      width: "16px",
                      height: "16px",
                      fontSize: "10px",
                      lineHeight: "16px",
                      textAlign: "center",
                    }}
                  >
                    +
                  </span>
                </label>
              </div>
            ) : (
              <img
                src={
                  site.adminImage ? URL.createObjectURL(site.adminImage) : user
                }
                alt=""
                className="rounded-circle"
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
            )}
          </div>

          {/* Active/De-active Button */}
          <div className="col-md-1">
            <button
              onClick={() => setPopup("active")}
              className={`${
                site.active ? "active-btn" : "deactive-btn"
              } w-100 border-0 py-1`}
            >
              {site.active ? "Active" : "De-active"}
            </button>
          </div>

          {/* Edit Button */}
          <div className="col-md-1 text-center">
            {site.editing ? (
              <button
                className="small-btn d-flex align-items-center justify-content-center mx-auto"
                onClick={() => handleEdit(site.id)}
              >
                <CheckCircleIcon fontSize="small" />
              </button>
            ) : (
              <button
                className="cust-btn mx-auto"
                onClick={() => handleEdit(site.id)}
              >
                <img src={edit_icon} alt="" className="edit-btn" />
              </button>
            )}
          </div>

          {/* Delete Button */}
          <div className="col-md-1 text-center">
            <button onClick={() => setPopup(true)} className="cust-btn mx-auto">
              <img src={delete_icon} alt="" className="edit-btn" />
            </button>
          </div>
        </div>
      ))}

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to{" "}
              {popup == "active" ? "deactivate" : "delete"} the site admin?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setConfirm(true)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {groupPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to delete the group user?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  deleteGroupUser(groupPopup);
                }}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setGroupPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {confirm && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              If you want to delete a site admin you need to add another one
            </p>
            <div className="m-3">
              <div className="col-md-9 mb-3">
                <input
                  className="input-box w-100"
                  name="adminName"
                  value={formData.adminName}
                  onChange={handleChange}
                  type="text"
                  placeholder="Site admin name"
                />
                {siteErrors.adminName && (
                  <p className="err">{siteErrors.adminName}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminEmail"
                  value={formData.adminEmail}
                  onChange={handleChange}
                  className="input-box w-100 "
                  type="email"
                  placeholder="Admin Email"
                />
                {siteErrors.adminEmail && (
                  <p className="err">{siteErrors.adminEmail}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminMobile"
                  value={formData.adminMobile}
                  onChange={handleChange}
                  className="input-box w-100 "
                  type="text"
                  placeholder="Mobile"
                />
                {siteErrors.adminMobile && (
                  <p className="err">{siteErrors.adminMobile}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminImage"
                  onChange={(e) => handleSiteImage(e, "adminImage")}
                  className="input-box w-100 "
                  type="file"
                  placeholder="Site Admin Image"
                  accept="image/*"
                />
                {siteErrors.adminImage && (
                  <p className="err">{siteErrors.adminImage}</p>
                )}
              </div>
            </div>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setConfirm(false);
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      <hr className="border-t-2 border-gray-400 my-5" />

      {type != "view" && (
        <div className="d-flex flex-wrap gap-5">
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Name<span className="text-danger">*</span>
            </p>
            <input
              className={`input-box ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Site Name"
              disabled={
                emailCheckFlag == 0
                  ? true
                  : emailCheckData?.company?.site?.name
                    ? true
                    : false
              }
            />
            {errors.name && <p className="err">{errors.name}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Code<span className="text-danger">*</span>
            </p>
            <input
              className={`input-box ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
              name="code"
              value={formData.code}
              onChange={handleChange}
              type="text"
              placeholder="Site Code"
              disabled={
                emailCheckFlag == 0
                  ? true
                  : emailCheckData?.company?.site?.code
                    ? true
                    : false
              }
            />
            {errors.code && <p className="err">{errors.code}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Address<span className="text-danger">*</span>
            </p>
            <input
              className={`input-box ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
              name="address"
              value={formData.address}
              onChange={handleChange}
              type="text"
              placeholder="Site Address"
              disabled={
                emailCheckFlag == 0
                  ? true
                  : emailCheckData?.company?.site?.address
                    ? true
                    : false
              }
            />
            {errors.address && <p className="err">{errors.address}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Location<span className="text-danger">*</span>
            </p>

            <select
              name="location"
              value={formData?.location}
              onChange={handleChange}
              className={`input-box ${emailCheckFlag == 0 ? "opacity-50" : ""}`}
              type="text"
              disabled={
                emailCheckFlag == 0
                  ? true
                  : emailCheckData?.company?.site?.location
                    ? true
                    : false
              }
            >
              <option>Select Location</option>
              {locList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
            {errors.location && <p className="err">{errors.location}</p>}
          </div>

          {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") ||
          givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE") ? (
            <div className="d-flex w-90 justify-content-end pe-5 me-5">
              {flagEmail == 0 && type == "edit" && (
                <button
                  // onClick={handleSiteAdd}
                  onClick={() => handleSubmit()}
                  className="medium-btn ms-4"
                >
                  Save
                </button>
              )}
            </div>
          ) : null}
        </div>
      )}

      {/* {type == "view" && (
        <div className="d-flex flex-wrap gap-5">
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Name & Code
            </p>
            <input
              className="input-box"
              name="name"
              value={`${formData?.name} - ${formData?.code}`}
              readOnly
              type="text"
              placeholder="Site Name"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Code
            </p>
            <input
              className="input-box"
              name="code"
              value={formData?.code}
              readOnly
              type="text"
              placeholder="Site Code"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Address
            </p>
            <input
              className="input-box"
              name="address"
              value={formData?.address}
              readOnly
              type="text"
              placeholder="Site Address"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Location
            </p>
            <select
              name="location"
              value={formData?.location}
              className="input-box"
              type="text"
              disabled
            >
              <option>Select Location</option>
              {locList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      )} */}

      {/* Site */}

      {/* <hr className="border-t-2 border-gray-400 mb-5" /> */}

      {/* {type == "edit" &&
      (givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") ||
        givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE")) ? (
        <button
          onClick={handleSubmit}
          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Update
        </button>
      ) : null} */}

      {type === "view" && btnTab == 1 && (
        <div className="w-100">
          {/* <hr className="border-t-2 border-gray-400 my-5" /> */}
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 black">
            Group Users Section
          </p>

          {type === "view" && (
            <>
              <div className="row mt-4 g-3 align-items-end">
                <div className="col-md-2 position-relative">
                  <p className="f3 mb-1 primary">
                    Email<span className="text-danger">*</span>
                  </p>
                  <input
                    name="groupEmail"
                    value={groupForm.groupEmail}
                    onChange={(val) => {
                      handleGroupChange(val);
                      setGroupForm((prev) => ({
                        ...prev,
                        groupEmail_verify: false,
                      }));
                      setFlagEmail2(1);
                    }}
                    className="input-box w-100 "
                    type="email"
                    placeholder="Email"
                    // disabled={groupForm?.id ? true : false}
                  />
                  {groupErrors.groupEmail && (
                    <p className="err">{groupErrors.groupEmail}</p>
                  )}
                  {groupForm?.groupEmail?.length > 2 && (
                    <p
                      className="position-absolute text-primary pointer end-0 fw-bold"
                      onClick={() => {
                        if (groupForm?.id) {
                          if (fullData2?.email == groupForm.groupEmail) {
                            toast.error("Same Email Entered");
                            setTimeout(() => {
                              window.location.reload();
                            }, 2000);
                          } else {
                            emailCheckGroup(2);
                          }
                        } else {
                          emailCheckGroup(2);
                        }
                      }}
                    >
                      Check
                    </p>
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    User Name<span className="text-danger">*</span>
                  </p>
                  <input
                    className={`input-box ${!groupForm?.groupEmail_verify ? "opacity-50" : ""}`}
                    ref={groupNameRef}
                    name="groupName"
                    value={groupForm.groupName}
                    onChange={handleGroupChange}
                    type="text"
                    placeholder="Group user name"
                    disabled={!groupForm?.groupEmail_verify}
                  />
                  {groupErrors.groupName && (
                    <p className="err">{groupErrors.groupName}</p>
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    Singapore Mobile<span className="text-danger">*</span>
                  </p>
                  <input
                    name="groupMobile"
                    value={groupForm.groupMobile}
                    maxLength={8}
                    onChange={handleGroupChange}
                    className={`input-box ${!groupForm?.groupEmail_verify ? "opacity-50" : ""}`}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 8))
                    }
                    type="number"
                    placeholder="+65 Mobile"
                    disabled={!groupForm?.groupEmail_verify}
                  />
                  {groupErrors.groupMobile && (
                    <p className="err">{groupErrors.groupMobile}</p>
                  )}
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p
                    className="f3 primary d-flex"
                    style={{ marginBottom: "-4%" }}
                  >
                    User Image
                  </p>
                  <span className="text-danger fs-12">
                    JPG, JPEG, PNG only | Max size: 5MB
                  </span>
                  <input
                    ref={fileInputRef}
                    name="groupImage"
                    onChange={(e) => handleGroupImage(e, "groupImage")}
                    className={`input-box ${!groupForm?.groupEmail_verify ? "opacity-50" : ""}`}
                    type="file"
                    accept="image/*"
                    placeholder="User Image"
                    disabled={!groupForm?.groupEmail_verify}
                    style={{
                      display: "none",
                    }}
                  />
                  <div className="col-md-3 d-flex ac-jb gap-3 ms-5">
                    <img
                      src={
                        groupForm.groupImage
                          ? typeof groupForm.groupImage === "string"
                            ? groupForm.groupImage
                            : window.URL.createObjectURL(groupForm.groupImage)
                          : user_img
                      }
                      alt="group Logo"
                      className={`user pointer ${!groupForm?.groupEmail_verify ? "opacity-50" : ""}`}
                      style={{
                        borderRadius: "50px",
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                      onClick={() => fileInputRef.current?.click()}
                    />

                    <img
                      src={edit_icon}
                      alt="Edit"
                      className={`edit-btn pointer ${!groupForm?.groupEmail_verify ? "opacity-50" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => fileInputRef.current?.click()}
                      disabled={!groupForm?.groupEmail_verify ? true : false}
                    />
                  </div>
                  {/* {groupErrors.groupImage && (
                    <p className="err">{groupErrors.groupImage}</p>
                  )} */}
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    Select Group<span className="text-danger">*</span>
                  </p>

                  <select
                    name="groupCategory"
                    onChange={handleGroupChange}
                    value={groupForm.groupCategory}
                    className="input-box w-100"
                    disabled={!groupForm?.groupEmail_verify}
                  >
                    <option value={""}>Select</option>
                    {groupList?.map((item, ind) => {
                      return (
                        <option value={item?.id} key={ind}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>

                  {groupErrors.groupCategory && (
                    <p className="err">{groupErrors.groupCategory}</p>
                  )}
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-end">
                  {flagEmail2 == 0 && (
                    <button
                      onClick={handleGroupAdd}
                      className="submit-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-center gap-5 me-5 mt-3">
                {/* Alert Notifications */}

                {/* {groupForm.groupCategory == "group1" && (
                  <div className="d-flex flex-column flex-start">
                    <label className="form-label">Select Group User</label>
                    <SelectBox
                      arrayData={cameraData}
                      selectedOption={selectedCamera}
                      setSelectedOption={setSelectedCamera}
                      style={true}
                    />
                  </div>
                )} */}

                <div className="d-flex flex-column align-items-center me-5">
                  <p className="f3 mb-1 primary">Alert Notifications</p>

                  {!groupForm.alert ? (
                    <ToggleOffIcon
                      sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                      onClick={() => {
                        setGroupForm((prev) => ({
                          ...prev,
                          alert: 1,
                        }));
                        setGroupErrors((prev) => ({
                          ...prev,
                          alert: "",
                          beep: "",
                        }));
                      }}
                    />
                  ) : (
                    <ToggleOnIcon
                      sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          alert: 0,
                        }))
                      }
                    />
                  )}

                  {/* Reserve space for error */}
                  <div style={{ minHeight: "20px" }}>
                    {groupErrors.alert && (
                      <p className="text-danger small mb-0">
                        {groupErrors.alert}
                      </p>
                    )}
                  </div>
                </div>

                {/* Beep Sound */}
                <div className="d-flex flex-column align-items-center ms-5">
                  <p className="f3 mb-1 primary">Beep Sound</p>

                  {!groupForm.beep ? (
                    <ToggleOffIcon
                      sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          beep: 1,
                          alert: 1,
                        }))
                      }
                    />
                  ) : (
                    <ToggleOnIcon
                      sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          beep: 0,
                        }))
                      }
                    />
                  )}

                  {/* Reserve space for error */}
                  <div style={{ minHeight: "20px" }}>
                    {groupErrors.beep && (
                      <p className="text-danger small mb-0">
                        {groupErrors.beep}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* {type == "view" && groupUsers.length == 0 ? (
            <div className="text-center mt-5 p-5 border rounded bg-light">
              <p className="mb-0 f3 text-muted">
                No group users found for this site.
              </p>
            </div>
          ) : (
            type == "view" && <CompanyGroupView groupUsers={groupUsers} />
          )} */}

          {/* Render list */}
          {type === "view" && (
            <CompanySitesAdd
              groupUsers={groupUsers}
              setGroupPopup={setGroupPopup}
              type={type}
              deleteGroupUser={deleteGroupUser}
              handleGroupEdit={handleGroupEdit}
              groupUserStatus={groupUserStatus}
            />
          )}

          {type == "view" && groupUsers.length == 0 && (
            <div className="text-center mt-5 p-5 border rounded bg-light">
              <p className="mb-0 f3 text-muted">
                No group users found for this site.
              </p>
            </div>
          )}
        </div>
      )}

      {btnTab == 2 && <CompanyAllReports />}
      {btnTab == 3 && <CompanyIndNotifications />}
      {btnTab == 4 && <CompanySlotMain type={"slot"} />}
      {btnTab == 5 && <AlertMainCompany siteId={siteID} />}
      {btnTab == 6 && <CameraCompanySite />}
      <div className="d-flex ac-jb mt-5">
        {type == "edit" &&
        (givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") ||
          givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE")) ? (
          <>
            {emailCheckData?.id && flagEmail2 == 0 ? (
              <button
                disabled={
                  emailCheckData?.email == formData.adminEmail ? false : true
                }
                onClick={() => {
                  handleGroupAdd();
                }}
                className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  ${
                  emailCheckData?.email == formData.adminEmail
                    ? ""
                    : "opacity-50"
                }`}
              >
                Group User Submi
              </button>
            ) : flagEmail2 == 0 ? (
              <></>
            ) : // <button
            //   onClick={() => {
            //     handleGroupAdd();
            //   }}
            //   className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            // >
            //   Group User Submit
            // </button>
            null}
          </>
        ) : null}

        {type == "add" &&
        (givenpermissions?.includes("CAN-Edit-KNF_COMPANY_SITE") ||
          givenpermissions?.includes("CAN-Add-KNF_COMPANY_SITE")) ? (
          <>
            {emailCheckData?.id && flagEmail == 0 ? (
              <button
                disabled={
                  emailCheckData?.email == formData.adminEmail ? false : true
                }
                onClick={() => {
                  handleSubmit();
                }}
                className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  ${
                  emailCheckData?.email == formData.adminEmail
                    ? ""
                    : "opacity-50"
                }`}
              >
                Submit
              </button>
            ) : flagEmail == 0 ? (
              <button
                onClick={() => {
                  handleSubmit();
                }}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                Submit
              </button>
            ) : null}
          </>
        ) : null}
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>
      </div>
      <div>
        {deletePopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
                Are you sure, want to Delete?
              </p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button onClick={() => setDeletePopup("")} className="no-btn">
                  No
                </button>
                <button
                  onClick={() => {
                    // handleDelete();
                    setDeletePopup(false);
                    setDeleteSiteAdmin(true);
                    // setFormData("")
                  }}
                  className="yes-btn f2"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
        {deleteSiteAdmin && (
          <div className="popup-design">
            <div className="popup">
              <div className=" ">
                <div className="d-flex ac-jb">
                  <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Delete Site Admin
                  </h2>
                  <button
                    onClick={() => {
                      setDeleteSiteAdmin(false);
                    }}
                    className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                  >
                    <CancelIcon />
                  </button>
                </div>
                <div className="position-relative mt-4">
                  <p className="f3 mb-1 primary">Admin Email</p>
                  <input
                    name="adminEmail2"
                    value={formData.adminEmail2}
                    onChange={(e) => {
                      setFormData((pre) => ({
                        ...pre,
                        adminEmail2: e.target.value,
                      }));
                    }}
                    className="input-box w-100 "
                    type="email"
                    placeholder="Admin Email"
                  />
                  {errors.adminEmail2 && (
                    <p className="err">{errors.adminEmail2}</p>
                  )}
                  <p
                    className="position-absolute text-primary pointer end-0 fw-bold"
                    onClick={() => emailCheck(1, "email2")}
                  >
                    Check
                  </p>
                  {/* )} */}
                </div>
                <div className=" mt-3">
                  <p className="f3 mb-1 primary">Site admin name</p>
                  <input
                    className="input-box w-100"
                    name="adminName2"
                    value={formData.adminName2}
                    onChange={(e) => {
                      setFormData((pre) => ({
                        ...pre,
                        adminName2: e.target.value,
                      }));
                    }}
                    type="text"
                    placeholder="Site admin name"
                    disabled={emailCheckData?.name ?? false}
                  />
                  {errors.adminName2 && (
                    <p className="err">{errors.adminName2}</p>
                  )}
                </div>

                <div className="mt-3">
                  <p className="f3 mb-1 primary">Singapore Mobile</p>
                  <input
                    name="adminMobile2"
                    value={formData.adminMobile2}
                    onChange={(e) => {
                      setFormData((pre) => ({
                        ...pre,
                        adminMobile2: e.target.value,
                      }));
                    }}
                    maxLength={8}
                    className="input-box w-100 "
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 8))
                    }
                    type="number"
                    placeholder="+65 Mobile"
                    disabled={emailCheckData?.phone ?? false}
                  />
                  {errors.adminMobile2 && (
                    <p className="err">{errors.adminMobile2}</p>
                  )}
                </div>

                <div className="mt-3">
                  <p className="f3 mb-1 primary">Site Admin Image</p>
                  <input
                    name="adminImage"
                    onChange={(e) => {
                      setFormData((pre) => ({
                        ...pre,
                        adminImage: e.target.files[0],
                      }));
                    }}
                    className="input-box w-100 "
                    type="file"
                    placeholder="Site Admin Image"
                    accept="image/*"
                  />
                  {errors.adminImage && (
                    <p className="err">{errors.adminImage}</p>
                  )}
                </div>
                <div className="d-flex ac-jc">
                  <button
                    onClick={() => {
                      // handleDelete();
                      handleDeleteSiteAdmin();
                      // setDeletePopup(false);
                      setDeleteSiteAdmin(2);
                    }}
                    className="submit-btn f2 my-4"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {open && <CommonImagePopup img={open} setOpen={setOpen} />}
      </div>
    </div>
  );
};

export default CompanySitesView;
